function ThumbsUpIcon({ color = 'currentColor', height = '24', width = '24' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M15.0003 17.4997H5.83366V6.66634L11.667 0.833008L12.7087 1.87467C12.8059 1.9719 12.8857 2.10384 12.9482 2.27051C13.0107 2.43717 13.042 2.5969 13.042 2.74967V3.04134L12.1253 6.66634H17.5003C17.9448 6.66634 18.3337 6.83301 18.667 7.16634C19.0003 7.49967 19.167 7.88856 19.167 8.33301V9.99967C19.167 10.0969 19.1531 10.2011 19.1253 10.3122C19.0975 10.4233 19.0698 10.5275 19.042 10.6247L16.542 16.4997C16.417 16.7775 16.2087 17.0136 15.917 17.208C15.6253 17.4025 15.3198 17.4997 15.0003 17.4997ZM7.50033 15.833H15.0003L17.5003 9.99967V8.33301H10.0003L11.1253 3.74967L7.50033 7.37467V15.833ZM5.83366 6.66634V8.33301H3.33366V15.833H5.83366V17.4997H1.66699V6.66634H5.83366Z"
        fill={color}
      />
    </svg>
  );
}
export default ThumbsUpIcon;
